import * as types from '../mutation-types'
import docService from '../../services/docs'
import {calcDiscount} from '../../common/index'


const state = {
  loading: false,
  errors: '',
  trpts: [],
  bills: [],
  perfrpt: [],
}

const actions = {
  getTRpts({ commit }, data) { //class terminal report
    commit(types.DOC_LOADING, true)
    docService.getTRpts(data).then(
      response => {

        commit(types.LOAD_TRPTS, response.data)
        commit(types.DOC_LOADING, false)
      },
      error => {
        commit(types.DOC_FAILURE, error)
        commit(types.DOC_LOADING, false)
      }
    )
  },
  getBills({ commit }, data) { //class bill
    commit(types.DOC_LOADING, true)
    docService.getBills(data).then(
      response => {

        commit(types.LOAD_BILLS, response.data)
        commit(types.DOC_LOADING, false)
      },
      error => {
        commit(types.DOC_FAILURE, error)
        commit(types.DOC_LOADING, false)
      }
    )
  },
  getPerfRpt({ commit }, data) { //performance report for one students
    commit(types.DOC_LOADING, true)
    docService.getPerfRpt(data).then(
      response => {

        commit(types.LOAD_PERFRPTS, response.data)
        commit(types.DOC_LOADING, false)
      },
      error => {
        commit(types.DOC_FAILURE, error)
        commit(types.DOC_LOADING, false)
      }
    )
  },

}

const mutations = {

  [types.LOAD_TRPTS](state, payload) {
    state.trpts = payload
  },
  [types.LOAD_BILLS](state, payload) {
    state.bills = payload

    if (state.bills.c_bill.feestr) {

      state.bills.c_bill.feestr.adcharges.unshift({ charge_item: "Term's School Fees", amount: payload.c_bill.feestr.basic_amt })

      let new_cls_bill = state.bills.c_bill.feestr.adcharges
      let new_c_list = []
      state.bills.c_list.forEach(s => {

        s.s_bill={
          chgs:[],
          tot_fee:null,
          tot_disc:null
        }
        s.s_bill.chgs = JSON.parse(JSON.stringify(new_cls_bill)) //deep cloning class bill to prevent source (new_cls_bill) from been updated with s.s_bill.chgs
        let spcharges = JSON.parse(s.p_charges) //student personal charges = spcharges

        if(spcharges){ //adding student personal charges to student bill incase there is any
          let cgs  = [...s.s_bill.chgs,...spcharges]

          s.s_bill.chgs = JSON.parse(JSON.stringify(cgs))
        }
        let tot_fee = s.s_bill.chgs.reduce((sum, x) => { //calculating overall total fee for student
          return sum + Number(x.amount)
        }, 0)

        s.s_bill.tot_fee = tot_fee //setting overall total fee for student

        if (s.fees_arrears > 0) { //setting fee arrears for student incase there is any
          let arrears_model = {
            charge_item: "Arrears From Last Term",
            amount: s.fees_arrears,
          };


          s.s_bill.chgs.push(arrears_model);
        }



        if (s.s_discount) { //setting discount value for student if there is any
          let discVal = calcDiscount(s.s_discount, tot_fee);
          s.s_bill.tot_disc = discVal
          s.s_discount.tot_disc = discVal
          s.s_bill.chgs[0].crecharge_item = s.s_discount.category;
          s.s_bill.chgs[0].creamount = discVal;

        }else{

        }

        new_c_list.push(s)
      })

      //console.log(new_c_list)
      state.bills.c_list = new_c_list


    }


  },
  [types.LOAD_PERFRPTS](state, payload) {
    state.perfrpt = payload
  },

  [types.DOC_FAILURE](state, payload) {
    state.errors = payload
  },

  [types.DOC_LOADING](state, payload) {
    state.loading = payload
  },
}


const getters = {
  TRPTS: state => {
    return state.trpts
  },
  BILLS: state => {
    return state.bills
  },
  PERFRPT: state => {
    return state.perfrpt
  },

  DOC_ERROR: state => {
    return state.errors
  },

  DOC_LOADING: state => {
    return state.loading
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/docs.js